<template>
    <div>
        <PageLoader :isPage="true" :isLoaded="false" />
    </div>
</template>
<script>
    import { reactive, toRefs, onMounted } from "vue";
    import { useRouter } from "vue-router";
    import { useStore } from "vuex";

    import { Links } from "@/helpers/links";
    import { appData } from "@/helpers/global";
    import { Web } from "@/helpers/web";

    import PageLoader from "@/components/PageLoader.vue"; 
    import { StoreUser } from "@/store/constants";

    export default {
        name: "DefaultView",
        components: {
            PageLoader
        },
        setup() {
            const router = useRouter();
            const store = useStore();

            const e = reactive({
                detect() {
                    router.push(Links.Url(Links.Dashboard));
                }
            });
            onMounted(() => {
                try {
                    setTimeout(() => { e.detect(); }, 10);
                } catch (ex) { console.warn(ex.message); }
            });
            return { ...toRefs(e) };
        },
    };
</script>
